import React, { useCallback, useEffect, useState } from 'react'
import { BrowserRouter as Router, Route, Switch ,withRouter} from 'react-router-dom';
import Home from "./view/home/home.js";
import People from './view/People/People.js';
import Research from './view/Research/Research.js';
import Resources_home from "./view/Resources&Link/Resources_home.js";
import DashBoard from "./view/Resources&Link/DashBoard.js";
import Super_GUC from "./view/Research/Super_GUC.js";
import Wait_page from "./view/Wait_page.js";
import Publications_1 from "./view/Publications/selected_publications.js";
import Nav from './view/nav.js';
import Footer from './view/footer.js';
import Map from './view/Map.js';
import './reset.css';
import './App.css';
function App() {
  return (

      <Router>
        <Nav/>
        <Route exact path="/" component={Home}/>
        <Route exact path="/People" component={People}/>
        <Route exact path="/Research" component={DashBoard}/>
        <Route exact path="/Resources" component={Super_GUC}/>
        <Route path="/Research/:name" component={Research}/>
        <Route path="/Resources/:name" component={Resources_home}/>
        <Route path="/publications/:name" component={Publications_1}/>
        <Route path="/Map" component={Map}/>
        <Footer/>
    </Router>
  );
}

export default App;
